import { AsiDialog } from '@asi-ngtools/lib';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Rx';
import { AsiDialogService } from '@asi-ngtools/lib';
import { ConfirmModal } from "./confirm/confirm.modal";
import { InfoModal } from "./info/info.modal";ModalService

@Injectable()
export class ModalService {

  constructor(private asiDialogService: AsiDialogService) {
  }

  openModal(content: any): Observable<any> {
    return this.asiDialogService.fromComponent(content, null).onDialogClose();
  }

  openConfirmDialog(title: string, question: string, confirmButton?: string, cancelButton?: string): AsiDialog<any> {
    const confirmModalRef = this.asiDialogService.fromComponent(ConfirmModal, null);
    confirmModalRef.getComponent().title = title;
    confirmModalRef.getComponent().question = question;
    if (confirmButton) {
      confirmModalRef.getComponent().confirmButton = confirmButton;
    } else {
      confirmModalRef.getComponent().confirmButton = 'MODAL.CONFIRM.confirm';
    }
    if (cancelButton) {
      confirmModalRef.getComponent().cancelButton = cancelButton;
    } else {
      confirmModalRef.getComponent().cancelButton = 'MODAL.CONFIRM.cancel';
    }
    return confirmModalRef;
  }

  openInfoDialog(title: string, question: string, confirmButton?: string): AsiDialog<any> {
    const infoModalRef = this.asiDialogService.fromComponent(InfoModal, null);
    infoModalRef.getComponent().title = title;
    infoModalRef.getComponent().question = question;
    if (confirmButton) {
      infoModalRef.getComponent().confirmButton = confirmButton;
    } else {
      infoModalRef.getComponent().confirmButton = 'MODAL.INFO.confirm';
    }
    return infoModalRef;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/modal.service.ts